import React from "react";
import { injectIntl } from "react-intl";
import { makeStyles } from "@material-ui/core";

import ReportTable from "../ReportTable";
import ContractSummary from "./ContractSummary";
import AnimatedCardContent from "../../AnimatedCardContent";

import { useContractReportColumns } from "./useContractReportColumn";
import { useInfiniteAsyncScroll } from "../../../../hooks/useInfiniteAsyncScroll";
import { resolveErrorMessage } from "../../../../util";

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    fontSize: theme.typography.caption.fontSize,
  },
  secondary: {
    color: theme.palette.text.secondary,
  },
}));

const mapperReponse = (res) => ({
  newItems: res?.contracts ?? [],
  total: res?.totals?.contractCount ?? 0,
  additionalData: res?.totals,
});

const ContractReportTable = ({ fetchContractsReport, filters, currentUser, setOrderBy, setSort, intl, showExclusiveCommissions, reportKey, customerRoutePrefix }) => {
  const classes = useStyles();

  const {
    items: contracts,
    additionalData: summary,
    loading,
    error,
    scrollTriggerRef,
  } = useInfiniteAsyncScroll({
    onScroll: fetchContractsReport,
    params: filters,
    take: 40,
    idField: "contractId",
    mapResponse: mapperReponse,
  });

  const allColumns = useContractReportColumns({ currentUser, intl, classes, customerRoutePrefix });
  const availableColumns = React.useMemo(() => (showExclusiveCommissions ? allColumns : allColumns.filter((c) => !c.exclusive)), [allColumns, showExclusiveCommissions]);

  const normalizedError = error ? resolveErrorMessage(error) : null;

  return (
    <>
      <ContractSummary
        disabled={loading || error}
        error={error}
        loading={loading}
        summary={summary}
      />
      <AnimatedCardContent>
        <ReportTable
          availableColumns={availableColumns}
          currentUser={currentUser}
          title="app.list.contracts"
          data={contracts}
          loading={loading}
          error={normalizedError}
          enableCopy
          fetchAllData={fetchContractsReport}
          rowsPath="contracts"
          params={filters}
          filters={filters}
          orderBy={filters.orderBy}
          sort={filters.sort}
          setOrderBy={setOrderBy}
          setSort={setSort}
          reportKey={reportKey}
        />
      </AnimatedCardContent>
      <div ref={scrollTriggerRef} />
    </>
  );
};

export default injectIntl(ContractReportTable);
